import { render, staticRenderFns } from "./PosInventoryDetail.vue?vue&type=template&id=421e6992&scoped=true&"
import script from "./PosInventoryDetail.vue?vue&type=script&lang=js&"
export * from "./PosInventoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421e6992",
  null
  
)

export default component.exports